<div class="grid align-items-center">
  <div class="breadcrumb col-12">
    <div class="flex align-items-center">
      <h3>Ticket</h3>
    </div>

    <!-- Tabella -->
    <div
      class="tbl max-w-full"
      *ngIf="deliveryID">
      <p-table
        [paginator]="true"
        [value]="delivery_histories"
        #ticketTable
        [rows]="25"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="rowsPerPageOptions"
        [lazy]="true"
        (onLazyLoad)="fetchDeliveryHistory(deliveryID, $event)"
        [totalRecords]="total_records"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali">
        <ng-template pTemplate="header">
          <tr>
            <th>Utente</th>
            <th>Stato</th>
            <th>Data</th>
          </tr>
        </ng-template>
        <ng-template
          pTemplate="body"
          let-d>
          <tr>
            <td>
              <span class="mb-0"> {{ d.created_by.name }} {{ d.created_by.last_name }}</span
              ><br />
              <small class="grey-text"> {{ d.created_by?.username }} </small><br />
              <small class="grey-text">
                {{ d.created_by?.email }}
              </small>
            </td>
            <td>
              <span class="mb-0"> {{ d.related_status.description }} </span>
            </td>
            <td>{{ d.date | date: 'dd MMM yyyy HH:mm:ss' }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td
              colspan="3"
              class="py-2 text-center">
              Nessun risultato.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
